import React from "react";
import { Button } from "../../../common/u1/Button";
import { SuccessMark } from "../../../common/u1/SuccessMark";
import { ArrowRight } from "../../../../assets/ui/icons";

/* Step 6 — the claim is done. Nothing is pending: ICC-01 completes the claim
   on submit, so this screen hands over the profile rather than promising a
   review. */
export const SubmittedStep = ({
  companyName = "",
  note,
  onMyBusinesses,
  onViewProfile,
}) => (
  <div className="py-5 text-center" role="status">
    <SuccessMark />

    <h2 className="mt-[18px] text-[24px] font-bold tracking-[-0.02em] text-[var(--ink)] font-sans">
      {companyName ? `${companyName} is now yours` : "This company is now yours"}
    </h2>

    <p className="mx-auto mt-2.5 max-w-[480px] text-[14px] leading-[1.55] text-[var(--ink-2)] font-sans">
      You can edit the profile, upload documents, and start receiving enquiries
      right away.
    </p>

    {(onMyBusinesses || onViewProfile) && (
      <div className="mt-[22px] flex flex-col items-stretch justify-center gap-2.5 sm:flex-row sm:items-center">
        {onMyBusinesses && (
          <Button variant="outline" onClick={onMyBusinesses} className="h-[46px] px-5">
            My Businesses
          </Button>
        )}
        {onViewProfile && (
          <Button onClick={onViewProfile} className="h-[46px] px-5">
            Go to company profile <ArrowRight size={14} />
          </Button>
        )}
      </div>
    )}

    {note && (
      <p className="mx-auto mt-4 max-w-[480px] text-[13px] text-[var(--muted)] font-sans">
        {note}
      </p>
    )}
  </div>
);

export default SubmittedStep;
